function articleSearch() {
	const forms = document.querySelectorAll('.articleSearch') as NodeListOf<Element>;
	var form: Element ;
	for (var i=0; i < forms.length; i++) {
		form = forms[i];
		if (form instanceof HTMLFormElement) {
			form.addEventListener(
				'change',
				(event: Event) => (form as HTMLFormElement).submit(),
				false
			);
		}
	}
}

export default articleSearch;
